import React, {useState} from "react";
import {Image} from "@chakra-ui/react"
import Field from "../Field.tsx";
import SmartIcon from "../SmartIcon.tsx";
import useUserStore from "../../store/useUserStore.ts";

const EditProfile: React.FC = () => {
  const {user} = useUserStore()
  const [objectURL, setObjectURL] = useState<string>(user?.avatarSasLink || "");
  const [name, setName] = useState<string>(user ? `${user?.firstName} ${user?.lastName}` : "");
  const [bio, setBio] = useState<string>("");

  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files[0]) {
      const file = e.target.files[0];
      // setImage(file);
      setObjectURL(URL.createObjectURL(file));
    }
  };

  return (
    <form className="" action="" onSubmit={() => console.log("Submit")}>
      <div className="mb-6 h4 md:mb-6">Edit profile</div>
      <div className="mb-1 base2 font-semibold text-n-600 dark:text-n-100">
        Avatar
      </div>
      <div className="flex items-center mb-2">
        <div
          className="relative flex justify-center items-center shrink-0 w-18 h-18 mr-4 rounded-full overflow-hidden bg-n-200 dark:bg-n-600">
          {objectURL !== null ? (
            <Image
              src={objectURL}
              alt="Avatar"
              className="w-full h-full object-cover"
            />
          ) : (
            <SmartIcon
              className="w-8 h-8 dark:fill-n-100"
              name="profile"
            />
          )}
        </div>
        <div className="grow">
          <div className="relative inline-flex mb-2">
            <input
              className="peer absolute inset-0 opacity-0 cursor-pointer"
              type="file"
              onChange={handleUpload}
            />
            <button className="btn-stroke-light peer-hover:bg-n-300 dark:peer-hover:bg-n-500">
              Upload new image
            </button>
          </div>
          {/*<div className="caption1 text-n-400">*/}
          {/*  <p>JPG or PNG</p>*/}
          {/*</div>*/}
        </div>
      </div>
      <Field
        className="mb-3"
        label="Name"
        placeholder="Username"
        icon="profile-1"
        value={name}
        onChange={(event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => setName(event.target.value)}
        required
      />
      <Field
        className="mb-3"
        label="Bio"
        placeholder="Short bio"
        icon="user-check"
        value={bio}
        onChange={(event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => setBio(event.target.value)}
        textarea
      />
      <button className="btn-purple w-full">Save changes</button>
    </form>
  );
};

export default EditProfile;
